import React from "react";
import {
  Grid,
  TextField,
  MenuItem,
  Typography,
  Box
} from "@mui/material";

export default function ProductDealsSection({ values, setFieldValue }) {
  const dealType = Number(values.dealType || 0);

  const handleDealTypeChange = (e) => {
    const value = Number(e.target.value);

    setFieldValue("dealType", value);
    setFieldValue("dealQuantity", "");
    setFieldValue("dealPrice", "");
    setFieldValue("discountPercent", "");
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="h6" sx={{ mb: 2, textAlign: "right" }}>
        מבצע למוצר
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            select
            fullWidth
            label="סוג מבצע"
            value={dealType}
            onChange={handleDealTypeChange}
          >
            <MenuItem value={0}>ללא מבצע</MenuItem>
            <MenuItem value={1}>X+1 חינם</MenuItem>
            <MenuItem value={2}>X ב־מחיר</MenuItem>
            <MenuItem value={3}>הנחה באחוזים</MenuItem>
          </TextField>
        </Grid>

        {(dealType === 1 || dealType === 2) && (
          <Grid item xs={12}>
            <TextField
              fullWidth
              type="number"
              label={
                dealType === 1
                  ? "כמה קונים כדי לקבל 1 חינם"
                  : "כמות במבצע"
              }
              value={values.dealQuantity || ""}
              onChange={(e) =>
                setFieldValue("dealQuantity", e.target.value)
              }
            />
          </Grid>
        )}

        {dealType === 2 && (
          <Grid item xs={12}>
            <TextField
              fullWidth
              type="number"
              label="מחיר המבצע"
              value={values.dealPrice || ""}
              onChange={(e) => setFieldValue("dealPrice", e.target.value)}
            />
          </Grid>
        )}

        {dealType === 3 && (
          <Grid item xs={12}>
            <TextField
              fullWidth
              type="number"
              label="אחוז הנחה"
              value={values.discountPercent || ""}
              onChange={(e) =>
                setFieldValue("discountPercent", e.target.value)
              }
            />
          </Grid>
        )}
      </Grid>
    </Box>
  );
}